import $ from 'jquery'
import Pikaday from 'pikaday'

export function init() {
  createDatePickers(document)

  $(document).on('ajax.replace', function () {
    createDatePickers(this)
  })
}

function createDatePickers(container) {
  $('[data-date-picker]', container).each((i, elem) => {
    new Pikaday({ field: elem, format: 'DD / MM / YYYY' })
  })
}
